export default {
  title: "Session details",
  tooltip: "Summary",
  "command.toggle": "Toggle summary",
  noBranch: "No branch",
  "move.title": "Move to worktree",
  "move.menu": "Move session to",
  "move.failed": "Failed to move session",
  server: "Extensions",
  mcp: "MCP",
  "mcp.title": "Configured MCP servers",
  "mcp.empty": "No MCP servers configured",
  plugins: "Plugins",
  "plugins.configured": "Configured plugins",
  "plugins.empty": "No plugins configured",
  skills: "Skills",
  "skills.configured": "Configured skills",
  "skills.empty": "No skills configured",
  lsp: "LSP",
  "lsp.configured": "Configured LSPs",
  "lsp.empty": "No LSP servers configured",
  failed: "Failed",
  retry: "Retry",
  connecting: "Connecting…",
  needsAuth: "Sign in required",
  configure: "Configuration file",
  copyConfigPath: "Copy configuration file path",
  configFileMissing: "No configuration file found",
  loadingChanges: "Loading changes…",
  noChanges: "No changes",
  basedOn: "Based on {{branch}}",
  "workspace.local": "Local repository",
  "workspace.existing": "Worktree",
  "workspace.new": "New worktree",
  "mcp.interactiveAuth": "MCP server {{name}} requires an interactive authentication form",
}
